export const services = [
  {
    id: 1,
    title: "Pompe à Chaleur",
    description: "Une technologie innovante pour un confort thermique durable, économique et respectueux de l'environnement",
    icon: "zap",
    image: "https://images.unsplash.com/photo-1700124113583-81aa99ea2aa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxoZWF0JTIwcHVtcHxlbnwwfHx8fDE3NzIwMzU1OTd8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Installation professionnelle",
      "Économies d'énergie",
      "Respectueux de l'environnement"
    ]
  },
  {
    id: 2,
    title: "Climatisation",
    description: "Des systèmes de climatisation fiables et performants, installés et entretenus pour votre bien-être au quotidien",
    icon: "wind",
    image: "https://images.unsplash.com/photo-1612836639523-2ed74bc0209e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzcyMDM1NTkzfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Installation professionnelle",
      "Systèmes fiables",
      "Systèmes performants"
    ]
  },
  {
    id: 3,
    title: "VMC & Ventilation",
    description: "Optimisez la qualité de l'air intérieur avec des solutions de ventilation fiables et adaptées à vos besoins",
    icon: "airVent",
    image: "https://images.pexels.com/photos/32032996/pexels-photo-32032996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Installation professionnelle",
      "Ventilation adaptée",
      "Qualité de l'air optimale",
      "Solutions fiables"
    ]
  },
  {
    id: 4,
    title: "Adoucisseur",
    description: "Des solutions d'adoucissement d'eau pour plus de confort, moins de calcaire et une meilleure durabilité de vos installations",
    icon: "droplet",
    image: "adouc.png",
    features: [
      "Moins de calcaire",
      "Plus de confort",
      "Durabilité accrue",
      "Installation complète"
    ]
  },
  {
    id: 5,
    title: "Chauffage",
    description: "Réparation, modernisation et amélioration de vos systèmes de chauffage pour plus d'efficacité et d'économies d'énergie",
    icon: "flame",
    image: "chauffage.png",
    features: [
      "Réparation rapide",
      "Modernisation système",
      "Efficacité énergétique",
      "Économies d'énergie"
    ]
  },
  {
    id: 6,
    title: "Chauffe Eau",
    description: "Des solutions complètes pour l'installation, le remplacement et la maintenance de votre chauffe-eau en toute sérénité",
    icon: "thermometer",
    image: "chaufo3.png",
    features: [
      "Installation complète",
      "Remplacement rapide",
      "Maintenance préventive",
      "Service en sérénité"
    ]
  }
];

export const advantages = [
  {
    id: 1,
    title: "Expertise Certifiée",
    description: "Plus de 15 ans d'expérience avec des techniciens qualifiés RGE",
    icon: "award"
  },
  {
    id: 2,
    title: "Intervention Rapide",
    description: "Disponibilité 7j/7 pour vos urgences et dépannages",
    icon: "clock"
  },
  {
    id: 3,
    title: "Garantie Qualité",
    description: "Garantie sur toutes nos installations et interventions",
    icon: "shield"
  },
  {
    id: 4,
    title: "Devis Gratuit",
    description: "Estimation précise et transparente sans engagement",
    icon: "calculator"
  }
];

export const stats = [
  {
    id: 1,
    value: "2000+",
    label: "Clients satisfaits"
  },
  {
    id: 2,
    value: "15+",
    label: "Années d'expérience"
  },
  {
    id: 3,
    value: "98%",
    label: "Taux de satisfaction"
  },
  {
    id: 4,
    value: "24/7",
    label: "Service disponible"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    location: "Béthune",
    rating: 5,
    comment: "Installation d'une pompe à chaleur parfaitement réalisée. Équipe professionnelle et à l'écoute. Je recommande vivement !",
    service: "Pompe à chaleur"
  },
  {
    id: 2,
    name: "Jean Martin",
    location: "Lille",
    rating: 5,
    comment: "Intervention rapide pour un dépannage de climatisation. Service impeccable et prix transparent.",
    service: "Climatisation"
  },
  {
    id: 3,
    name: "Sophie Laurent",
    location: "Arras",
    rating: 5,
    comment: "Très satisfaite du système de chauffage modernisé. Économies d'énergie au rendez-vous !",
    service: "Chauffage"
  }
];